<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const emit = defineEmits(['add']);
const { t } = useI18n();
const root = ref(null);
const open = ref(false);

const menuSections = computed(() => [
  {
    title: t('SALES_PARTIES.ACTIONS.ADD_MENU_TITLE'),
    items: [
      {
        action: 'add',
        value: 'pessoa_fisica',
        label: t('SALES_PARTIES.LIST.PERSON_TYPE'),
        icon: 'i-lucide-user',
      },
      {
        action: 'add',
        value: 'pessoa_juridica',
        label: t('SALES_PARTIES.LIST.COMPANY_TYPE'),
        icon: 'i-lucide-users',
      },
    ],
  },
]);

const close = () => {
  open.value = false;
};

const select = item => {
  close();
  emit('add', item.value);
};

const closeOnOutside = event => {
  if (!root.value?.contains(event.target)) close();
};

onMounted(() => document.addEventListener('mousedown', closeOnOutside));
onBeforeUnmount(() =>
  document.removeEventListener('mousedown', closeOnOutside)
);
</script>

<template>
  <div ref="root" class="relative" @keydown.esc.stop="close">
    <LaisPrimaryButton
      icon="i-lucide-plus"
      aria-haspopup="menu"
      :aria-expanded="open ? 'true' : 'false'"
      data-test="sales-party-add-trigger"
      @click="open = !open"
    >
      {{ t('SALES_PARTIES.ACTIONS.ADD') }}
    </LaisPrimaryButton>
    <DropdownMenu
      v-if="open"
      id="sales-party-add-menu"
      :menu-sections="menuSections"
      class="right-0 top-full mt-1 w-56"
      data-test="sales-party-add-menu"
      @action="select"
    />
  </div>
</template>
